import { Autocomplete } from "./";
import { useUser } from "../hooks/query";

interface User {
    Id: string;
    FirstName: string;
    LastName: string;
    Email: string;
    IsActive?: boolean;
}

interface UserDropdownProps {
    name: string;
    label: string;
    placeholder?: string;
    rules?: object;
    helperText?: string;
    size?: "sm" | "md" | "lg";
    disabled?: boolean;
    filterActive?: boolean; // Only show active users
}

function UserDropdown({
    name,
    label,
    placeholder = "Select user",
    rules = {},
    helperText,
    size = "md",
    disabled = false,
    filterActive = true, // Default to showing only active users
    ...props
}: UserDropdownProps) {
    const { useList } = useUser();
    const { data, isLoading } = useList();

    const users = ((Array.isArray(data) ? data : []) as User[]).filter((user) =>
        filterActive ? user.IsActive !== false : true,
    );

    const userOptions = users.map((user) => {
        const fullName = [user.FirstName, user.LastName].filter(Boolean).join(" ").trim();
        return {
            value: user.Email,
            label: fullName || user.Email,
            ...user,
        };
    });

    return (
        <Autocomplete
            name={name}
            label={label}
            placeholder={placeholder}
            rules={rules}
            helperText={helperText}
            size={size}
            options={userOptions}
            disabled={disabled || isLoading}
            loading={isLoading}
            // Ensure Autocomplete can match the current value to an option
            isOptionEqualToValue={(option: any, value: any) => {
                if (!option || !value) return false;
                return option.value === value.value;
            }}
            // Ensure label renders correctly from option objects
            getOptionLabel={(option: any) => {
                if (typeof option === "string") return option;
                return option.label ?? "";
            }}
            {...props}
        />
    );
}

export { UserDropdown };
